import Vendors from "@pages/Vendors";
import VendorsDetail from "@pages/Vendors/Detail";
import VendorDetailInfoProfile from "@pages/Vendors/Detail/Detail-Info/Profile";
import VendorsDetailInfoUsers from "@pages/Vendors/Detail/Detail-Info/Users";
import VendorsLocations from "@pages/Vendors/Detail/Detail-Info/Locations";
import VendorsHeadCount from "@pages/Vendors/Detail/Detail-Info/HeadCount";
import VendorsCreate from "@pages/Vendors/Create";
import UserLocationMapping from "@pages/Vendors/Detail/Detail-Info/Users/location-mapping";
import VendorsEmail from "@pages/Vendors/Detail/Detail-Info/Email";

export const VendorRoutes = [
	{ path: "/configuration/vendors", name: "configuration_vendor", component: Vendors  },
	{ path: "/configuration/vendors/add", name: "configuration_vendor", component: VendorsCreate  },
	{ path: "/configuration/vendors/add/:id", name: "configuration_vendor", component: VendorsCreate  },
	{
		path: "/configuration/vendors/detail/:id",
		name: "configuration_vendor",
		component: VendorsDetail ,
	},
	{
		path: "/configuration/vendors/detail-info/profile/:parentId",
		name: "configuration_vendor",
		component: VendorDetailInfoProfile ,
	},
	{
		path: "/configuration/vendors/detail-info/profile/:parentId/:id",
		name: "configuration_vendor",
		component: VendorDetailInfoProfile ,
	},
	{
		path: "/configuration/vendors/detail-info/users/:parentId/:id",
		// name: "vendor_vendor_user",
		name:'configuration_vendor',
		component: VendorsDetailInfoUsers ,
	},
	{
		path: "/configuration/vendors/detail-info/map-to-locations/:parentId/:id",
		// name: "vendor_map_to_location",
		name:'configuration_vendor',
		component: VendorsLocations ,
	},
	{
		path: "/configuration/vendors/detail-info/headcount/:parentId/:id",
		// name: "vendor_headcount",
		name:'configuration_vendor',
		component: VendorsHeadCount ,
	},
	{
		path: "/configuration/vendors/detail-info/email/:parentId/:id",
		name: "configuration_vendor",
		component: VendorsEmail ,
	},
	{
		path: "/configuration/vendors/detail-info/users/location-mapping/:grandParentId/:parentId/:id",
		// name: "vendor_vendor_user",
		name:'configuration_vendor',
		component: UserLocationMapping ,
	},
];
